"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATE_FEATURES = exports.PRODUCT_LINE_LABELS = exports.PRODUCT_LINES = void 0;
exports.resolveProductLine = resolveProductLine;
exports.resolveBusinessLine = resolveBusinessLine;
exports.isPackageAllowedForBusiness = isPackageAllowedForBusiness;
exports.findProductLineConflicts = findProductLineConflicts;
/**
 * Product lines (owner decision 2026-10-08). A business runs ONE line; packages
 * belong to a line or are 'shared'. Missing anywhere ⇒ 'rubytill', so every
 * record written before this existed keeps today's behaviour.
 * NOT the legacy `productType` field — never read or write that for this.
 */
exports.PRODUCT_LINES = ['rubytill', 'rubyestate', 'shared'];
exports.PRODUCT_LINE_LABELS = {
    rubytill: 'Ruby Till',
    rubyestate: 'Ruby Estate',
    shared: 'Shared — both lines',
};
function resolveProductLine(v) {
    return v === 'rubyestate' || v === 'shared' ? v : 'rubytill';
}
function resolveBusinessLine(v) {
    return v === 'rubyestate' ? 'rubyestate' : 'rubytill';
}
function isPackageAllowedForBusiness(businessLine, packageLine) {
    const p = resolveProductLine(packageLine);
    return p === 'shared' || p === resolveBusinessLine(businessLine);
}
function findProductLineConflicts(businessLine, pkgs) {
    return pkgs.filter(p => !isPackageAllowedForBusiness(businessLine, p.productLine));
}
/**
 * Estate FEATURE keys — the only Estate identifiers code may check.
 * Which packages carry these features, and which line each package is on,
 * is admin data (Super Admin › Packages) and can change at any time.
 * Never hardcode package ids for gating.
 */
exports.ESTATE_FEATURES = {
    core: 'estate.core',
    units: 'estate.units',
    leasing: 'estate.leasing',
    maintenance: 'estate.maintenance',
    autopay: 'estate.autopay',
    website: 'estate.website',
};
//# sourceMappingURL=productLine.js.map